module.exports = __webpack_public_path__ + "img/dashboard-black.1bb9107c.svg";